import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ColumnList from '../ColumnList/ColumnList';
import s from './LocationList.css';

const isMobile = __APP__ === 'mobile';
class LocationList extends Component {
  static propTypes = {
    cities: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
      }),
    ),
    columnCount: PropTypes.number,
    selectedLocation: PropTypes.shape(),
    search: PropTypes.bool,
    titleKey: PropTypes.string,
    title: PropTypes.string,
    isRegion: PropTypes.bool,
  };

  static defaultProps = {
    countries: [],
    cities: [],
    columnCount: 5,
    search: false,
    isRegion: false,
    selectedLocation: undefined,
    titleKey: 'title',
    title: '',
  };

  createColumns = (arr, columnCount) => {
    const maxColumnLength = Math.ceil(arr.length / columnCount);

    return arr.reduce(
      (result, item, i) =>
        i % (maxColumnLength > 6 ? 6 : maxColumnLength) === 0
          ? [...result, [item]]
          : [...result.slice(0, result.length - 1), [...result[result.length - 1], item]],
      [],
    );
  };

  render() {
    const { cities, columnCount, search, selectedLocation, isRegion, titleKey, title } = this.props;
    const citiesColumns = this.createColumns(cities, columnCount);
    const rooClass = isMobile ? s.rootMobile : s.root;
    return (
      <div className={rooClass}>
        {title &&
          <div className={s.title}>
            {title}
          </div>}
        <div>
          <ColumnList
            selectedLocation={selectedLocation}
            search={search}
            isRegion={isRegion}
            resetHeader={
              isRegion
                ? <FormattedMessage id={search ? 'Популярные запросы' : 'Вся Украина'} />
                : ''
            }
            list={citiesColumns}
            className={s.citiesList}
            titleKey={titleKey}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(LocationList);



// WEBPACK FOOTER //
// ./src/desktop/components/Footer/LocationList/LocationList.js